import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class GeoLoadDirectionTypeModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (GeoLoadDirectionTypeModel._instance == null) GeoLoadDirectionTypeModel._instance = new GeoLoadDirectionTypeModel(authManager);
        return GeoLoadDirectionTypeModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'model-sections/geo-load-direction-types', 'model-sections/geo-load-direction-types/codelist');

        this.entityName = 'model-sections.GeoLoadDirectionType';
        this.privileges = {
            create: [["#admin"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["#admin"]],
            delete: [["#admin"]],
        };

        this.label = 'Load Direction Type';
        this.setLabel = 'Load Direction Types';

        this.browser = {
            name: 'default-model-sections-geoloaddirectiontype-browser',
            moduleName: 'default-model-sections-geoloaddirectiontype-browser',
            moduleTitle: 'Load Direction Types',
            moduleStateSlotName: 'default-model-sections-geoloaddirectiontype-browser',
        };

        this.editor = {
            name: 'default-model-sections-geoloaddirectiontype-editor',
            moduleName: 'default-model-sections-geoloaddirectiontype-editor',
            moduleTitle: 'Load Direction Type',
            moduleStateSlotName: 'default-model-sections-geoloaddirectiontype-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
            {
                name: 'directionAngle',
                type: 'float',
                persistent: true,
                unit: 'deg',
                label: 'Direction Angle',
            },
        ];

    }

}
